import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { Bar } from "react-chartjs-2";

import configs from "./configs";

function MasterUpdationBarChart({ color, title, description, date, chart }) {
  const { data, options } = configs(chart.labels || [], chart.datasets || []);

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        <MDBox
          sx={{
            height: "30rem",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <MDBox
            variant="gradient"
            bgColor={color}
            borderRadius="lg"
            coloredShadow={color}
            py={2}
            pr={0.5}
            height={`${chart.labels.length * 45}px`}
          >
            <Bar data={data} options={options} />
          </MDBox>
        </MDBox>

        <MDBox pt={3} pb={1} px={1}>
          <MDTypography variant="h6">{title}</MDTypography>

          {description && (
            <MDTypography
              component="div"
              variant="button"
              color="text"
              fontWeight="light"
            >
              {description}
            </MDTypography>
          )}

          <Divider />

          <MDBox display="flex" alignItems="center">
            <MDTypography variant="button" color="text" fontWeight="light">
              {date}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

MasterUpdationBarChart.defaultProps = {
  color: "info",
  description: "",
  date: "",
};

MasterUpdationBarChart.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.string,
  chart: PropTypes.object.isRequired,
};

export default MasterUpdationBarChart;
